import ReactHtmlParser from 'react-html-parser'
import { cn } from '~/shadcn/lib/utils'

type Props = {
  html: string
  className?: string
}

/**
 * Hodnota riadku detailu zadaná v BO cez Froala (HTML) — vlastné texty zabezpečenia
 * (kolaterál, LTL, znalecká / tržná hodnota). Zarovnané doprava ako ostatné hodnoty;
 * tučné písmo neriadi FE, nastavuje ho admin vo WYSIWYG. Tailwind preflight ruší
 * odrážky, tu sa pre `ul`/`ol` vracajú (inside, aby sedeli pri texte zarovnanom doprava).
 */
export function DetailHtmlValue({ html, className }: Props) {
  return (
    <div
      className={cn(
        'text-end font-normal',
        '[&_ul]:list-disc [&_ul]:list-inside [&_ol]:list-decimal [&_ol]:list-inside',
        '[&_p:not(:last-child)]:mb-1',
        className
      )}>
      {ReactHtmlParser(html)}
    </div>
  )
}
